export default {
    // 用户登录
    login: 'login',
    // 课程管理
    course: 'course',
    // 课程新增
    courseAdd: 'courseAdd',
    // 课程详情
    courseDetail: 'courseDetail',
    // 课程更新
    courseModify: 'courseModify',
    // 订单管理
    buy: 'buy',
    // 订单管理
    buyDetail: 'buyDetail',
    // 订单修改
    buyModify: 'buyModify',
    // 分销查询
    seller: 'seller',
    // 提现记录
    cash: 'cash',
    // 会员管理
    user: 'user',
    // 用户详情
    userDetail: 'userDetail',
    // 用户退款
    userRefund: 'userRefund',
    // 用户通知
    userNotice: 'userNotice',
    // 意见反馈
    suggest: 'suggest',
    // 意见详情
    suggestDetail: 'suggestDetail',
    // 通知栏
    topNoticeSetting: 'topNoticeSetting',
    // 设置管理
    topBannerSetting: 'topBannerSetting',
    // 广告位管理
    midAdSetting: 'midAdSetting',
    // 小工具
    tools: 'tools',
    // 修改密码
    password: 'password',
}